class QuizConditionalContentService {
  static toggle(container, fieldOptionId) {
    let matched = false;

    container
      .querySelectorAll(".cf-quiz-conditional-content-item")
      .forEach((item) => {
        const isMatch =
          fieldOptionId != null &&
          item.getAttribute("data-field-option-id") == fieldOptionId;
        item.style.display = isMatch ? "block" : "none";
        if (isMatch) {
          matched = true;
        }
      });

    container.style.display = matched ? "block" : "none";
  }
}

export default QuizConditionalContentService;
